export default [
    {
        type: "uni",
        id: 1,
        items: [
            {
                id: 1,
                text: "Der Dozent/Die Dozentin war engagiert und motiviert.",
            },
            {
                id: 2,
                text: "Der Dozent/Die Dozentin hat die Inhalte angemessen wiederholt.",
            },
            {
                id: 3,
                text: "Ich konnte dem Tempo des Dozenten/der Dozentin gut folgen.",
            },
            {
                id: 4,
                text: "Der Dozent/Die Dozentin ermöglichte eine gute Lern- und Arbeitsatmosphäre.",
            },
            {
                id: 5,
                text: "Der Dozent/Die Dozentin gab die Möglichkeit, Themen zu diskutieren.",
            },
            {
                id: 6,
                text: "Der Dozent/Die Dozentin war stets gut vorbereitet.",
            },
            {
                id: 7,
                text: "Der Dozent/Die Dozentin war fachlich kompetent.",
            },
            {
                id: 8,
                text: "Der Dozent/Die Dozentin konnte Kompliziertes verständlich machen.",
            },
            {
                id: 9,
                text: "Der Dozent/Die Dozentin motivierte die Teilnehmer/innen.",
            },
            {
                id: 10,
                text: "Der Dozent/Die Dozentin formulierte bereits zu Beginn transparent die erforderlichen Prüfungsleistungen.",
            },
            {
                id: 11,
                text: "Das Lernziel wurde mir deutlich.",
            },
            {
                id: 12,
                text: "Die angestrebten Lernziele wurden von vorneherein gut definiert.",
            },
            {
                id: 13,
                text: "Die Veranstaltung war übersichtlich und verständlich.",
            },
            {
                id: 14,
                text: "Der inhaltliche Aufbau der Veranstaltung war logisch/nachvollziehbar.",
            },
            {
                id: 15,
                text: "Ich habe mich schon vor der Veranstaltung für das Thema interessiert.",
            },
            {
                id: 16,
                text: "Ich habe das Gefühl in der Veranstaltung Wichtiges gelernt zu haben.",
            },
            {
                id: 17,
                text: "Das behandelte Thema enthält Bezüge zu meiner späteren Berufstätigkeit.",
            },
            {
                id: 18,
                text: "Das Thema wurde gut durch Anwendungsbeispiele abgebildet.",
            },
            {
                id: 19,
                text: "Das behandelte Thema ist für meine berufliche, universitäre und/oder persönliche Entwicklung relevant.",
            },
            {
                id: 20,
                text: "Die Schwere des Stoffes war angemessen.",
            },
            {
                id: 21,
                text: "Der Umfang des Stoffes war angemessen.",
            },
            {
                id: 22,
                text: "Das Tempo der Veranstaltung war angemessen.",
            },
            {
                id: 23,
                text: "Die Anforderungen der Veranstaltung waren angemessen.",
            },
            {
                id: 24,
                text: "Der Zeitaufwand für die Veranstaltung insgesamt (inkl. Vor- und Nachbereitung) war angemessen.",
            },
            {
                id: 25,
                text: "Insgesamt hat mich die Veranstaltung überfordert.",
            },
            {
                id: 26,
                text: "Der Umfang der Arbeitsaufträge (d.h. Hausaufgaben, Gruppenarbeiten etc.) war angemessen.",
            },
            {
                id: 27,
                text: "Die Arbeitsaufträge haben mein Verständnis der Inhalte vertieft.",
            },
            {
                id: 28,
                text: "Die Arbeitsaufträge verdeutlichten die Relevanz der behandelten Themen.",
            },
            {
                id: 29,
                text: "Ich wurde durch Arbeitsaufträge zum Mitdenken motiviert.",
            },
            {
                id: 30,
                text: "Zur kritischen Auseinandersetzung mit den behandelten Themen wurde durch Arbeitsaufträge angeregt.",
            },
            {
                id: 31,
                text: "Die Arbeitsaufträge motivierten dazu, sich selbst mit den Inhalten zu beschäftigen.",
            },
            {
                id: 32,
                text: "Der Praxisbezug der Arbeitsaufträge wurde deutlich.",
            },
            {
                id: 33,
                text: "Das Feedback zu den Arbeitsaufträgen war hilfreich für mich.",
            },
            {
                id: 34,
                text: "Insgesamt fand ich die Veranstaltung gut.",
            },
            {
                id: 35,
                text: "In der Veranstaltung habe ich viel gelernt.",
            },
            {
                id: 36,
                text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
            },
            {
                id: 37,
                text: "Ich würde die Veranstaltung weiterempfehlen.",
            },
        ],
    },
    {
        type: "text",
        id: 2,
        items: [
            {
                id: 38,
                text: "Anmerkungen (Lob, Kritik)",
            },
        ],
    },
    {
        type: "age",
        id: 3,
        items: [
            {
                id: 39,
                text: "Alter: ",
            },
        ],
    },
];